import React from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuLink} from '../utils/types';

export const ecommercePayments: MenuLink[] = [
  {icon: 'mobile', slug: 'tpv-virtual', title: 'TPV Virtual'},
  {icon: 'globe', slug: 'online-payments', title: <Trans>Online payments</Trans>},
  {icon: 'split-payments', slug: 'features/monei-flex', title: <Trans>BNPL payments</Trans>}
];

export const inPersonPayments: MenuLink[] = [
  {icon: 'freelancer', slug: 'monei-pay', title: <Trans>Hardwareless POS system</Trans>},
  {icon: 'qr-icon', slug: 'monei-pay/qr', title: <Trans>QR Code Payments</Trans>}
];

export const omnichannelPayments: MenuLink[] = [
  {icon: 'payment-gateway', slug: 'payment-gateway', title: <Trans>Payment Gateway</Trans>},
  {
    icon: 'payments-orchestration',
    slug: 'features/payments-orchestration',
    title: <Trans>Payments Orchestration</Trans>
  },
  {icon: 'api-integration', slug: 'connect', title: 'MONEI Connect'}
];

export const paymentsSecurity: MenuLink[] = [
  {
    icon: 'network-tokenization',
    slug: 'features/network-tokenization',
    title: <Trans>Network Tokenization</Trans>
  },
  {icon: 'legal', slug: 'pci-dss', title: 'PCI DSS Level 1'},
  {
    icon: 'risk-management',
    to: 'https://monei.com/blog/psd2/',
    toByLanguage: {es: 'https://monei.com/es/blog/psd2/'},
    title: 'PSD2'
  },
  {
    icon: 'card',
    to: 'https://monei.com/blog/what-is-3d-secure-and-its-advantages-for-e-commerce/',
    toByLanguage: {
      es: 'https://monei.com/es/blog/what-is-3d-secure-and-its-advantages-for-e-commerce/'
    },
    title: <Trans>3D Secure</Trans>
  }
];

export const otherFeatures: MenuLink[] = [
  {
    icon: 'bizum',
    slug: 'bizum-empresas',
    title: <Trans>Bizum for businesses</Trans>
  },
  {
    icon: 'recurring',
    slug: 'features/subscriptions',
    title: <Trans>Recurring payments / subscriptions</Trans>
  },
  {icon: 'pay-by-link', slug: 'features/pay-by-link', title: 'Pay By Link'},
  {
    icon: 'fast-checkout',
    to: 'https://docs.monei.com/docs/integrations/build-custom-checkout/',
    toByLanguage: {es: 'https://docs.monei.com/es/integrations/build-custom-checkout/'},
    title: <Trans>Custom Checkout</Trans>
  },
  {
    icon: 'dashboard',
    slug: 'features/merchant-dashboard',
    title: <Trans>Real-time Payments Dashboard</Trans>
  }
];
